<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader">
      </loading>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-toolbar">
                    <div>
                        <h4 class="text-primary">Payment</h4>
                        <ol class="breadcrumb breadcrumb-card-header">
                            <li class="breadcrumb-item">
                              <a href="javascript:void(0);" @click="backParent">Sales Payment</a>
                            </li>
                            <li class="breadcrumb-item active">
                              <span v-if="payment.id === null">New</span>
                              <span v-else>{{ payment.group_no }}</span>
                            </li>
                        </ol>
                        <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="payment.group_no !== null">Action</button>
                        <div class="dropdown-menu" aria-labelledby="printsales">
                          <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false">Request Edit</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="print">Print</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="setJournal('reply')">Set Journal</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="voidPayment" v-if="authUser.permissions.sale_payment_void">Void</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="deletePayment" v-if="authUser.permissions.sale_payment_void">Delete</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="unlockPayment" v-if="authUser.permissions.sale_payment_void">Unlock</a>
                        </div>
                        <button type="button" @click="savePayment" class="btn btn-sm btn-soft-primary pull-left" v-show="payment.id === null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
                        <button type="button" @click="validate" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-check" aria-hidden="true"></i> Validate</button>
                        <button type="button" @click="updatePayment" class="btn btn-sm btn-soft-primary pull-left" v-show="payment.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
                        <button type="button" @click="approvePayment" class="btn btn-sm btn-hard-outline-primary pull-left" v-if="authUser.permissions.sale_payment_approve"><i class="fa fa-check"></i> Approve</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-list">
                    <div class="card-header">
                        <div class="col-md-12">
                            <h5 class="text-primary">
                            <span v-if="payment.id === null">New</span>
                            <span v-else>{{ payment.group_no }}</span>
                            <span class="badge badge-success ml-1" v-if="payment.status === 'approve'">{{ payment.status }}</span>
                            <span class="badge badge-primary ml-1" v-else>{{ payment.status }}</span>
                            </h5>
                        </div>
                    </div>
                    <div class="card-body">
                      <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                        <ul v-for="(a, index) in alert" :key="index">
                          <li v-html="a"></li>
                        </ul>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <dl class="row dl-custom font-12">
                            <dt class="col-md-4">Company</dt>
                            <dd class="col-md-8">
                              <select v-model="payment.company_no" class="form-control" :disabled="payment.id !== null" @change="setCompany">
                                <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                              </select>
                            </dd>
                            <dt class="col-md-4">Method</dt>
                            <dd class="col-md-8">
                              <select class="form-control form-control-lite" v-model="payment.method_id" @change="setMethod" :disabled="payment.lock">
                                <option v-for="m in methodList" :key="m.id" :value="m.id">{{ m.name }}</option>
                              </select>
                            </dd>

                            <dt class="col-md-4">Create Date</dt>
                            <dd class="col-md-8">
                              <span v-if="authUser.permissions.sale_backdate">
                                <span v-if="payment.lock === true">{{ payment.payment_date | dateFormat('DD/MM/YYYY') }}</span>
                                <datetime v-else v-model="payment.payment_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                              </span>
                              <span v-else>
                                <span v-if="payment.lock === true">{{ payment.payment_date | dateFormat('DD/MM/YYYY') }}</span>
                                <datetime v-else v-model="payment.payment_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" @input="checkDate"></datetime>
                              </span>
                            </dd>

                              <!-- <dt class="col-md-4" v-if="payment.method_id ===3">Giro Date</dt>
                              <dd class="col-md-8" v-if="payment.method_id ===3">
                                <datetime v-model="payment.prepayment_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                              </dd> -->

                              <dt class="col-md-4" v-if="payment.method_id ===3">Finish date</dt>
                              <dd class="col-md-6" v-if="payment.method_id ===3">
                                <span v-if="payment.lock === true">{{ payment.finish_date | dateFormat('DD/MM/YYYY') }}</span>
                                <datetime v-else v-model="payment.finish_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                              </dd>
                              <dd class="col-md-2" v-if="payment.method_id ===3">
                                <div class="custom-control custom-checkbox">
                                  <input type="checkbox" id="canBarcode" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="payment.finish" @input="resetFinish">
                                  <label for="canBarcode" class="custom-control-label">&nbsp;</label>
                                </div>
                              </dd>

                              <dt class="col-md-4" v-if="payment.method_id ===3">Giro No.</dt>
                              <dd class="col-md-8" v-if="payment.method_id ===3">
                                <span v-if="payment.lock === true">{{ payment.giro_no }}</span>
                                <input v-else type="text" class="form-control form-control-lite" v-model="payment.giro_no" />
                              </dd>

                              <dt class="col-md-4" v-if="payment.method_id ===3">Bank</dt>
                              <dd class="col-md-8" v-if="payment.method_id ===3">
                                <select v-model="payment.bank_id" class="form-control" :disabled="payment.lock">
                                  <option v-for="b in bankList" :key="b.id" :value="b.id">{{ b.name }}</option>
                                </select>
                              </dd>

                              <dt class="col-md-4" v-if="payment.method_id ===3">Bank Name</dt>
                              <dd class="col-md-8" v-if="payment.method_id ===3">
                                <span v-if="payment.lock === true">{{ payment.bank_name }}</span>
                                <input v-else type="text" class="form-control form-control-lite" v-model="payment.bank_name" />
                              </dd>

                              <dt class="col-md-4">Salesman</dt>
                              <dd class="col-md-8">
                                <v-select :options="getUserSalesman" :reduce="salesman => salesman.meta.code" label="salesman" v-model="payment.salesman_id" class="vsc-custom" :disabled="payment.lock"/>
                              </dd>
                          </dl>
                        </div>
                        <div class="col-md-6">
                          <dl class="row dl-custom">
                            <dt class="col-md-4">Amount</dt>
                            <dd class="col-md-8">
                                <span v-if="payment.lock == true">{{ payment.total | currency }}</span>
                                <input v-else class="form-control form-control-lite" type="text" v-model="payment.total" v-money="money" :disabled="payment.lock"/>
                            </dd>

                            <dt class="col-md-4">Account</dt>
                            <dd class="col-md-8">
                                <v-select class="vsc-custom" :options="accountSelect" :reduce="account => account.meta.code" label="account" v-model="payment.account_code" :disabled="payment.lock"/>
                            </dd>

                            <dt class="col-md-4">Customer</dt>
                            <dd class="col-md-6">
                              <v-select class="vsc-custom" :options="customerSelect" :reduce="customer => customer.meta.code" label="customer" v-model="payment.customer_no" :disabled="payment.lock"/>
                            </dd>

                            <dd class="col-md-2" v-if="payment.method_id !== 4">
                              <button type="button" class="btn btn-sm btn-hard-primary" @click="searchCustomer" :disabled="payment.lock" data-toggle="modal" data-target="#modalSalePaymentGroup" data-backdrop="static" data-keyboard="false" ><i class="fa fa-search"></i> Search</button>
                            </dd>

                            <dt class="col-md-4">Uang Muka</dt>
                            <dd class="col-md-6">
                              {{ totalUM | currency}}
                            </dd>

                            <dt class="col-md-4">Ref No.</dt>
                            <dd class="col-md-6">{{ payment.ref_no }}</dd>

                            <dt class="col-md-4">Journal Manual?</dt>
                            <dd class="col-md-6">
                              <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="canBarcode" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="payment.manual_journal">
                                <label for="canBarcode" class="custom-control-label">&nbsp;</label>
                              </div>
                            </dd>
                          </dl>
                        </div>
                      </div>
                      <hr>
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item"><a href="#payment" data-toggle="tab" aria-expanded="false" class="nav-link active">Payment</a></li>
                            <li class="nav-item"><a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link">Journal</a></li>
                            <li class="nav-item"><a href="#sales-data" data-toggle="tab" aria-expanded="false" class="nav-link">Sales</a></li>
                            <li class="nav-item"><a href="#um-data" data-toggle="tab" aria-expanded="false" class="nav-link">Uang Muka</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="payment">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="table-responsive">
                                    <table class="table table-item table-sm table-hover table-striped">
                                        <thead>
                                          <th></th>
                                          <th>Tgl.</th>
                                          <th>Sale No.</th>
                                          <th>Payment No</th>
                                          <th>Notes</th>
                                          <th>Amount</th>
                                          <th class="text-right">#</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(p, index) in payment.sales" :key="p.id">
                                              <td>
                                                <span v-if="p.finish"><i class="fa fa-check" style="color: green;"></i></span>
                                              </td>
                                              <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                              <td>{{ p.sale_no }}</td>
                                              <td>{{ p.payment_no }}</td>
                                              <td>
                                                <select v-model="p.notes" class="form-control" :disabled="payment.lock">
                                                  <option value="titipan">Titipan</option>
                                                  <option value="pelunasan">Pelunasan</option>
                                                </select>
                                              </td>
                                              <td><input type="text" v-model="p.price" class="form-control form-control-right" v-money="money" :disabled="payment.lock"/></td>
                                              <td class="text-right">
                                                <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removePaymentSales(index)" :disabled="payment.lock"><i class="fa fa-trash"></i></button>
                                              </td>
                                            </tr>
                                            <!-- <tr>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td>Amount Due</td>
                                              <td class="text-right">{{ totalSalePaymentOutstanding | currency }}</td>
                                              <td></td>
                                            </tr> -->
                                            <tr>
                                              <td colspan="4"></td>
                                              <td class="text-right"><b>Subtotal:</b></td>
                                              <td class="text-right"><b>{{ totalProcessPayment | currency }}</b></td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <td colspan="4"></td>
                                              <td class="text-right"><b>Uang Muka:</b></td>
                                              <td class="text-right"><b>{{ totalUM | currency }}</b></td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <td colspan="4"></td>
                                              <td class="text-right"><b>Discount:</b></td>
                                              <td class="text-right">
                                                <input type="text" v-model="payment.discount" v-money="money" class="form-control form-control-right" @input="calcTotal"/>
                                              </td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <td colspan="4"></td>
                                              <td class="text-right"><b>Denda:</b></td>
                                              <td class="text-right">
                                                <input type="text" v-model="payment.penalty_amount" v-money="money" class="form-control form-control-right" @input="calcTotal"/>
                                              </td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <td colspan="4"></td>
                                              <td class="text-right"><b>Total:</b></td>
                                              <td class="text-right">{{ totalPayment | currency }}</td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <td colspan="4"></td>
                                              <td class="text-right"><b>Total Bayar:</b></td>
                                              <td class="text-right">{{ this.payment.total }}</td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <td colspan="4"></td>
                                              <td class="text-right"><b>Rounding:</b></td>
                                              <td class="text-right">{{ totalRounding | currency }}</td>
                                              <td></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="tab-pane" id="journal">
                              <div class="table-responsive">
                                <table class="table table-sm table-item table-hover table-striped">
                                  <thead>
                                    <th>Journal Code</th>
                                    <th>Date</th>
                                    <th>Account Code</th>
                                    <th>Remark</th>
                                    <th class="text-right">Debit</th>
                                    <th class="text-right">Credit</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="j in payment.journals" :key="j.id">
                                      <td>
                                        <span v-if="j.level === 1">
                                          <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                          <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                          <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                                        </span>
                                        <span v-else></span>
                                      </td>
                                      <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                                      <td>{{ j.remark }}</td>
                                      <td class="text-right">
                                        <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                                        <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                                        <span v-else></span>
                                      </td>
                                      <td class="text-right">
                                        <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                                        <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                                        <span v-else></span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <button type="button" class="btn btn-sm btn-success pull-right" @click="postJournal">Post</button>
                              </div>
                            </div>
                            <div class="tab-pane" id="sales-data">
                              <div class="table-responsive">
                                <table class="table table-sm table-item table-striped">
                                  <thead>
                                    <th>Sale No</th>
                                    <th>Payment No.</th>
                                    <th>Date</th>
                                    <th>Due Date</th>
                                    <th>Customer</th>
                                    <th>Salesman</th>
                                    <th>Method</th>
                                    <th class="text-right">Subtotal</th>
                                    <th class="text-right">Discount</th>
                                    <th class="text-right">Tax</th>
                                    <th class="text-right">Total</th>
                                    <th class="text-right">Outstanding</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="d in payment.saleData" :key="d.id">
                                      <td v-if="d.level ===1"><b>{{ d.sale_no }}</b></td>
                                      <td v-else>
                                        <span class="ml-5">
                                          <i>{{ d.payment_no }}</i>
                                        </span>
                                      </td>

                                      <td>{{ d.group_no }}</td>

                                      <td v-if="d.level === 1">{{ d.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td v-else>{{ d.payment_date | dateFormat('DD/MM/YYYY') }}</td>

                                      <td v-if="d.level === 1">{{ d.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td v-else></td>

                                      <td v-if="d.level === 1">{{ d.customer }}</td>
                                      <td v-else></td>

                                      <td v-if="d.level === 1">{{ d.salesman }}</td>
                                      <td v-else></td>

                                      <td v-if="d.level === 1"></td>
                                      <td v-else>{{ d.method }}</td>

                                      <td v-if="d.level === 1" class="text-right">{{ d.subtotal | currency }}</td>
                                      <td v-else class="text-right"></td>

                                      <td v-if="d.level === 1" class="text-right">{{ d.discount | currency }}</td>
                                      <td v-else class="text-right"></td>

                                      <td v-if="d.level === 1" class="text-right">{{ d.tax | currency }}</td>
                                      <td v-else class="text-right"></td>

                                      <td class="text-right">{{ d.total | currency }}</td>

                                      <td v-if="d.level === 1" class="text-right">{{ d.outstanding | currency }}</td>
                                      <td v-else class="text-right"></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="um-data">
                              <div class="table-responsive">
                                <button class="btn btn-sm btn-hard-primary" @click="getCustomerUM">Get UM</button>
                                <table class="table table-sm table-item table-hover table-striped">
                                  <thead>
                                    <th>Status</th>
                                    <th>Method</th>
                                    <th>Payment No</th>
                                    <th>Create Date</th>
                                    <th>Customer</th>
                                    <th>Ref No.</th>
                                    <th class="text-right">Total</th>
                                    <th>#</th>
                                  </thead>
                                  <tbody>
                                    <tr v-if="payment.refs.length == 0">
                                      <td colspan="7">
                                        <i>No Data</i>
                                      </td>
                                    </tr>
                                    <tr v-for="(r, index) in payment.refs" :key="r.id">
                                      <td>{{ r.status }}</td>
                                      <td>{{ r.method_id }}</td>
                                      <td>{{ r.payment_no }}</td>
                                      <td>{{ r.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ r.customer_no }}</td>
                                      <td>{{ r.ref_no }}</td>
                                      <td class="text-right">{{ r.total | currency }}</td>
                                      <td>
                                        <button type="button" class="btn btn-sm btn-outline-danger" @click="removeRefs(index)"><i class="fa fa-trash"></i></button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <SalesRequestModal @getRequestEdit='requestEdit'/>
        <SalePaymentGroupModal @processPayment="processPayment"/>
        <!-- <pre>{{ checkPelunasan }}</pre> -->
    </div>
</template>
<script>
import Axios from 'axios'
import { mapState } from 'vuex'
import SalesRequestModal from '@/components/sales/SalesRequestModal.vue'
import SalePaymentGroupModal from '@/components/payment/SalePaymentGroupModal.vue'
import { getHeader, paymentUrl, lockUrl, journalUrl, salesUrl, sale2Url } from '../../config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'PurchasingPaymentGroupForm',
  props: ['payment'],
  components: {
    SalesRequestModal,
    SalePaymentGroupModal,
    Loading
  },
  data () {
    return {
      alert: [],
      selectAll: false,
      selected: [],
      paymentData: {},
      dataRaw: [{
        id: 1,
        sale_no: null,
        sale_date: null,
        sale_due_date: null,
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        vendor: null,
        subtotal: '0',
        tax_id: null,
        tax: '0',
        taxes: null,
        discount: 0,
        total: '0',
        payment_total: '0',
        outstanding: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        type_id: null,
        lock: false,
        company_no: null,
        term_due_id: null,
        ext_no: null,
        sp_no: null,
        discount_percentage: null,
        schedule_payment_date: null
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true /* doesn't work with directive */
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#6ED861',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      customerList: state => state.customers.customerListLite,
      typeList: state => state.payments.typeList,
      methodList: state => state.payments.methodList,
      chartOfAccountList: state => state.accounts.chartOfAccountList,
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList,
      bankList: state => state.banks.bankList,
      employeeList: state => state.employees.employeeList
    }),
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    checkPelunasan () {
      var array = this.payment.sales
      var check = true
      for (let i = 0; i < array.length; i++) {
        if (array[i].notes !== 'pelunasan') {
          check = false
        }
      }
      return check
    },
    totalUM () {
      var sum = 0
      if (this.payment.method_id !== 4) {
        var array = this.payment.refs
        for (let i = 0; i < array.length; i++) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalPayment () {
      var discount = parseFloat(this.payment.discount.replace(/\./g, ''))
      var penalty = parseFloat(this.payment.penalty_amount.replace(/\./g, ''))
      var total = 0
      total = this.totalProcessPayment - this.totalUM - discount + penalty
      return total
    },
    totalRounding () {
      var totalPayment = parseFloat(this.payment.total.replace(/\./g, ''))
      var round = 0
      if (this.payment.method_id !== 4) {
        round = totalPayment - this.totalPayment
      }
      return round
    },
    totalSalePaymentOutstanding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].outstanding)
      }
      return sum
    },
    totalProcessPayment () {
      var sum = 0
      var array = this.payment.sales
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.toString().replace(/\./g, ''))
      }
      return sum
    },
    customerSelect () {
      var loop = []
      var array = this.customerList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          customer: array[i].customer_no + ' - ' + array[i].name,
          meta: {
            code: array[i].customer_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    accountSelectCheck () {
      var cmp = this.companyList.find(d => d.company_no === this.payment.company_no)
      var account = []
      if (cmp) {
        // var parentCode = cmp.acc_id + '-111-000'
        // var modalCode = cmp.acc_id + '-310-000'
        // var biayaCode = cmp.acc_id + '-610-000'
        account = this.chartOfAccountList.filter(d => d.company_no === this.payment.company_no).filter(d => d.hierarcy === 3)
      }
      return account
    },
    accountSelect () {
      var loop = []
      var array = []
      var methodID = this.payment.method_id === null || this.payment.method_id === '' ? 1 : this.payment.method_id
      if (methodID === 1) {
        array = this.accountSelectCheck
      } else {
        array = this.accountSelectCheck
      }
      for (let i = 0; i < array.length; i++) {
        var obj = {
          account: array[i].code + ' - ' + array[i].name,
          meta: {
            code: array[i].code
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  accountBiaya () {
    var cmp = this.companyList.find(d => d.company_no === this.payment.company_no)
    var biayaCode = cmp.acc_id + '-610-016'
    var chartBiaya = this.chartOfAccountList.filter(d => d.hierarcy === 3)
    var biayaKerugian = chartBiaya.find(d => d.code === biayaCode)
    return biayaKerugian
  },
  methods: {
    async unlockPayment () {
      await this.$swal.fire({
        title: 'Are you sure unlock this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, unlock it!'
      }).then((result) => {
        if (result.value) {
          Axios.post(paymentUrl + '/unlock', { id: this.payment.id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              this.payment.lock = false
            })
            .catch(error => {
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async deletePayment () {
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          console.log(paymentUrl + '/' + this.payment.id)
          Axios.delete(paymentUrl + '/' + this.payment.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              this.$emit('backSaveClicked')
            })
            .catch(error => {
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async validate () {
      this.alert = []
      if (this.payment.method_id == null) {
        this.alert.push('<b>Method</b> harus diinput terlebih dahulu')
      }
      if (this.payment.method_id !== 4) {
        var amount = parseFloat(this.payment.total.replace(/\./g, ''))
        if (amount < 1) {
          if (this.checkPelunasan === false) {
            this.alert.push('<b>Amount</b> harus diinput terlebih dahulu (tidak boleh kosong)')
          }
        }
      }
      if (this.payment.account_code == null) {
        this.alert.push('<b>Account</b> harus diinput terlebih dahulu')
      }
      if (this.payment.method_id !== 4) {
        if (parseFloat(this.payment.total) <= 0) {
          if (this.checkPelunasan === false) {
            this.alert.push('<b>Total Bayar</b> kurang dari nol (' + parseFloat(this.payment.total) + ')')
          }
        }
      }
    },
    async voidPayment () {
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        id: this.payment.id
      }
      await Axios.post(paymentUrl + '/void', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async resetFinish () {
      if (this.payment.finish === true) {
        this.payment.finish_date = null
      }
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.payment.payment_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = remaining / (1000 * 3600 * 24)
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 0) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.payment.payment_date = date1.toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.payment.payment_date = date1.toISOString()
      }
    },
    async removeRefs (index) {
      var ref = this.payment.refs[index]
      ref.ref_no = null
      this.payment.refs.splice(index, 1)
    },
    async getCustomerUM () {
      var obj = {
        customer_no: this.payment.customer_no
      }
      await Axios.post(paymentUrl + '/get-um-by-customer', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          console.log(response.data.data)
          var array = response.data.data
          for (let i = 0; i < array.length; i++) {
            var obj = {
              id: array[i].id,
              group_no: array[i].group_no,
              prepayment_date: array[i].prepayment_date,
              payment_date: array[i].payment_date,
              category: array[i].category,
              total: array[i].total,
              method_id: array[i].method_id,
              type_id: array[i].type_id,
              bank_id: array[i].bank_id,
              account_code: array[i].account_code,
              notes: array[i].notes,
              vendor_no: array[i].vendor_no,
              customer_no: array[i].customer_no,
              branch_no: array[i].branch_no,
              company_no: array[i].company_no,
              status: array[i].status,
              lock: array[i].lock,
              subtotal: array[i].subtotal,
              round: array[i].round,
              discount_percentage: array[i].discount_percentage,
              discount: array[i].discount,
              finish_date: array[i].finish_date,
              giro_no: array[i].giro_no,
              bank_name: array[i].bank_name,
              report_no: array[i].report_no,
              ref_no: this.payment.payment_no
            }
            this.payment.refs.push(obj)
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    setCompany () {
      this.payment.account_code = null
      this.payment.method_id = null
    },
    calcTotal () {
      var discount = this.payment.discount.replace(/\./g, '')
      var penalty = this.payment.penalty_amount.replace(/\./g, '')
      var total = parseFloat(this.totalProcessPayment) - parseFloat(discount) + parseFloat(penalty)
      console.log(total)
    },
    processPayment (value) {
      console.log('processPayment')
      console.log(value)
      const paymentDateNow = new Date(this.payment.payment_date)
      const newPaymentDate = paymentDateNow.getFullYear() + '-' + (paymentDateNow.getMonth() + 1) + '-' + paymentDateNow.getDate() + ' ' + '23:59:59'
      const paymentDate = new Date(newPaymentDate).getTime()
      const arrSales = value
      if (arrSales.length > 0) {
        for (let i = 0; i < arrSales.length; i++) {
          const salesDate = new Date(arrSales[i].sale_date).getTime()
          const saleDueDate = new Date(arrSales[i].sale_due_date).getTime()
          if (paymentDate < salesDate) {
            this.$swal('Error', 'Tanggal Payment tidak boleh kurang dari tanggal sales!!!!!!!' + newPaymentDate + ' ' + arrSales[i].sale_date, 'error')
            return false
          }
          if (arrSales[i].type === 'Cash Tunai') {
            console.log('sale: ' + arrSales[i].type)
            console.log(paymentDate + ' >< ' + saleDueDate)
            if (paymentDate > saleDueDate) {
              console.log('discount: ' + arrSales[i].discount)
              this.payment.penalty_amount = arrSales[i].discount
            }
          }
        }
      }
      this.getCustomerUM()
      var array = value
      for (let i = 0; i < array.length; i++) {
        var obj = {
          payment_no: null,
          sale_no: array[i].sale_no,
          payment_date: this.payment_date,
          price: array[i].outstanding,
          method_id: this.payment.method_id,
          type_id: this.payment.type_id,
          bank_id: this.payment.bank_id,
          notes: 'pelunasan',
          prepayment_date: this.payment.prepayment_date,
          group_no: this.payment.group_no,
          account_code: this.payment.account_code,
          lock: false
        }
        this.payment.sales.push(obj)
      }
    },
    async postJournal () {
      var array = this.payment.journals.filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        var data = {
          id: array[i].id
        }
        await Axios.post(journalUrl + '/posting', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            return false
          })
      }
      await this.$swal('Success', 'Success Post All Journal', 'success')
      await this.$emit('backClickID', this.payment.id)
    },
    async requestEdit (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.payment.group_no,
        lock_note: value,
        type: 'payment-sales'
      }
      await Axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Lock', 'Sales has been requested', 'success')
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    removePaymentSales (index) {
      var sales = this.payment.sales[index]
      if (typeof sales.id === 'undefined') {
        this.payment.sales.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(salesUrl + '/payment/' + sales.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.message)
                this.payment.sales.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          }
        })
      }
    },
    async setJournal (status) {
      var data = {
        id: this.payment.id
      }
      var type = this.payment.method_id
      if (type === 4) {
        console.log(paymentUrl + '/journal-sales-um')
        await Axios.post(paymentUrl + '/journal-sales-um', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            if (status === 'reply') {
              this.$swal('Success', response.data.message, 'success')
              this.$emit('backSaveClicked')
            }
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
          })
      } else {
        await Axios.post(paymentUrl + '/journal-sales', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            if (status === 'reply') {
              this.$swal('Success', response.data.message, 'success')
              this.$emit('backSaveClicked')
            }
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
          })
      }
    },
    async approvePayment () {
      if (this.authUser.permissions.sales_payment_create_admin === false) {
        await this.validate()
        if (this.alert.length > 0) {
          await window.scrollTo(0, 0)
          await this.$swal('Validation', 'Data Payment Belum valid, cek inputan terlebih dahulu', 'error')
          return false
        }
      }
      var data = {
        group_no: this.payment.group_no
      }
      await this.updatePayment()
      var message = {
        error: false,
        message: null
      }
      await Axios.post(paymentUrl + '/approve', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          message.error = false
          message.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          message.error = true
          message.message = error.response.data.message
          return false
        })
      await this.setJournal('noreply')
      if (message.error === false) {
        this.alert = []
        this.$swal('Success', message.message, 'success')
      } else {
        this.$swal('Error', message.message, 'error')
      }
      await this.$emit('backSaveClicked')
    },
    async updatePayment () {
      if (this.authUser.permissions.sales_payment_create_admin === false) {
        await this.validate()
        if (this.alert.length > 0) {
          await window.scrollTo(0, 0)
          await this.$swal('Validation', 'Data Payment Belum valid, cek inputan terlebih dahulu', 'error')
          return false
        }
      }
      var pdata = []
      var array = this.payment.sales
      for (let i = 0; i < array.length; i++) {
        var obj = {}
        if (typeof array[i].id === 'undefined') {
          obj = {
            payment_no: array[i].payment_no,
            sale_no: array[i].sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes,
            lock: array[i].lock,
            status: array[i].status,
            journal_code: array[i].journal_code,
            prepayment_date: array[i].prepayment_date,
            group_no: array[i].group_no,
            account_code: this.payment.account_code
          }
        } else {
          obj = {
            id: array[i].id,
            payment_no: array[i].payment_no,
            sale_no: array[i].sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes,
            lock: array[i].lock,
            status: array[i].status,
            journal_code: array[i].journal_code,
            prepayment_date: array[i].prepayment_date,
            group_no: array[i].group_no,
            account_code: this.payment.account_code
          }
        }
        pdata.push(obj)
      }
      var paymentDiscount = parseFloat(this.payment.discount.replace(/\./g, ''))
      var paymentDiscountPercentage = 0
      if (paymentDiscount !== 0) {
        paymentDiscountPercentage = (paymentDiscountPercentage / this.totalProcessPayment) * 100
      }
      var createDate = this.payment.payment_date
      var finishDate = this.payment.finish_date
      if (this.payment.method_id !== 3) {
        finishDate = this.payment.payment_date
      }
      var subtotal = null
      if (this.payment.method_id === 4) {
        subtotal = this.payment.total.replace(/\./g, '')
      } else {
        subtotal = this.totalProcessPayment
      }
      this.paymentData = {
        id: this.payment.id,
        group_no: this.payment.group_no,
        prepayment_date: this.payment.prepayment_date,
        finish_date: finishDate,
        payment_date: createDate,
        category: 'sales',
        total: this.payment.total.replace(/\./g, ''),
        method_id: this.payment.method_id,
        type_id: this.payment.type_id,
        bank_id: this.payment.bank_id,
        account_code: this.payment.account_code,
        notes: this.payment.notes,
        vendor_no: this.payment.vendor_no,
        customer_no: this.payment.customer_no,
        branch_no: this.authUser.branch_no,
        company_no: this.authUser.company_no,
        status: this.payment.status,
        subtotal: subtotal,
        discount: paymentDiscount,
        discount_percentage: paymentDiscountPercentage,
        round: this.totalRounding,
        penalty_amount: this.payment.penalty_amount.replace(/\./g, ''),
        lock: this.payment.lock,
        giro_no: this.payment.giro_no,
        bank_name: this.payment.bank_name,
        refs: this.payment.refs,
        sales: pdata,
        finish: this.payment.finish,
        manual_journal: this.payment.manual_journal
      }
      await Axios.put(paymentUrl + '/' + this.payment.id, this.paymentData, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.alert = []
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async savePayment () {
      if (this.authUser.permissions.sales_payment_create_admin === false) {
        await this.validate()
        if (this.alert.length > 0) {
          await window.scrollTo(0, 0)
          await this.$swal('Validation', 'Data Payment Belum valid, cek inputan terlebih dahulu', 'error')
          return false
        }
      }
      this.$Progress.start()
      this.loader.isLoading = true
      var pdata = []
      var array = this.payment.sales
      for (let i = 0; i < array.length; i++) {
        var obj = {}
        if (typeof array[i].id === 'undefined') {
          obj = {
            payment_no: array[i].payment_no,
            sale_no: array[i].sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes,
            lock: array[i].lock,
            status: array[i].status,
            journal_code: array[i].journal_code,
            prepayment_date: array[i].prepayment_date,
            group_no: array[i].group_no,
            account_code: this.payment.account_code
          }
        } else {
          obj = {
            id: array[i].id,
            payment_no: array[i].payment_no,
            sale_no: array[i].sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes,
            lock: array[i].lock,
            status: array[i].status,
            journal_code: array[i].journal_code,
            prepayment_date: array[i].prepayment_date,
            group_no: array[i].group_no,
            account_code: this.payment.account_code
          }
        }
        pdata.push(obj)
      }
      var paymentDiscount = parseFloat(this.payment.discount.replace(/\./g, ''))
      var paymentDiscountPercentage = 0
      if (paymentDiscount !== 0) {
        paymentDiscountPercentage = (paymentDiscountPercentage / this.totalProcessPayment) * 100
      }
      var createDate = this.payment.payment_date
      var finishDate = this.payment.finish_date
      if (this.payment.method_id !== 3) {
        finishDate = this.payment.payment_date
      }
      this.paymentData = {
        id: null,
        group_no: null,
        prepayment_date: this.payment.prepayment_date,
        finish_date: finishDate,
        payment_date: createDate,
        category: 'sales',
        subtotal: this.totalProcessPayment,
        round: this.totalRounding,
        penalty_amount: this.payment.penalty_amount.replace(/\./g, ''),
        discount: paymentDiscount,
        discount_percentage: paymentDiscountPercentage,
        total: this.payment.total.replace(/\./g, ''),
        method_id: this.payment.method_id,
        type_id: this.payment.type_id,
        bank_id: this.payment.bank_id,
        account_code: this.payment.account_code,
        notes: this.payment.notes,
        vendor_no: this.payment.vendor_no,
        customer_no: this.payment.customer_no,
        branch_no: this.payment.branch_no,
        company_no: this.payment.company_no,
        status: this.payment.status,
        lock: this.payment.lock,
        giro_no: this.payment.giro_no,
        bank_name: this.payment.bank_name,
        sales: pdata,
        refs: this.payment.refs,
        finish: this.payment.finish,
        manual_journal: this.payment.manual_journal
      }
      var resp = {
        error: false,
        message: null
      }
      await Axios.post(paymentUrl, this.paymentData, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
          this.payment.id = response.data.data.id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      // await this.setJournal('no reply')
      this.$Progress.finish()
      this.loader.isLoading = false
      if (resp.error === false) {
        this.alert = []
        await this.$swal('Success', resp.message, 'success')
        await this.$emit('backSaveClicked')
      }
    },
    async selectAllSales () {
      if (this.selectAll === false) {
        var array = this.dataRaw
        for (let i = 0; i < array.length; i++) {
          this.selected.push(array[i].id)
          this.setData(i)
        }
      } else {
        this.selected = []
        this.payment.sales = []
      }
    },
    async setData (index) {
      var data = this.dataRaw[index]
      var sales = this.payment.sales.find(d => d.sale_no === data.sale_no)
      var price = 0
      //  var salesIndex = this.payment.sales.findIndex(d => d.sale_no === data.sale_no)
      var obj = {}
      if (sales) {
        // price = sales.price.replace(/\./g, '')
        // if (price === 0) {
        //   this.payment.sales.splice(salesIndex, 1)
        // } else {
        //   sales.price = parseFloat(price) + parseFloat(data.outstanding)
        // }
      } else {
        var objPrice = price === 0 ? parseFloat(data.outstanding) : parseFloat(price) - parseFloat(data.outstanding)
        obj = {
          payment_no: null,
          sale_no: data.sale_no,
          payment_date: this.payment.payment_date,
          price: objPrice,
          method_id: this.payment.method_id,
          type_id: this.payment.type_id,
          bank_id: this.payment.bank_id,
          notes: this.payment.notes,
          prepayment_date: this.payment.prepayment_date,
          group_no: this.payment.group_no,
          account_code: this.payment.account_code,
          lock: false
        }
        this.payment.sales.push(obj)
      }
      // this.payment.total = this.totalProcessPayment
    },
    async searchCustomer () {
      this.dataRaw = []
      var data = {
        customer_no: this.payment.customer_no,
        year: this.payment.payment_date,
        company_no: this.payment.company_no,
        salesman: this.payment.salesman_id
      }
      this.$store.dispatch('getCustomerOutstading', data)
    },
    backParent () {
      this.alert = []
      this.$emit('backClicked')
    },
    setMethod () {
      var methodID = this.payment.method_id
      if (methodID === 1) {
        if (this.payment.company_no === 'C0001') {
          this.payment.account_code = '01-111-002'
        } else {
          this.payment.account_code = '11-111-002'
        }
        this.payment.prepayment_date = null
      } else if (methodID === 3) {
        if (this.payment.id == null) {
          this.payment.prepayment_date = null
          this.payment.payment_date = null
        }
      } else {
        this.payment.account_code = null
        this.payment.prepayment_date = null
      }
    },
    async print () {
      window.open(sale2Url + '/print/' + this.payment.id + '/kwitansi', '_blank')
    }
  }
}
</script>
